import { render, staticRenderFns } from "./TodosStaleAssemblies.vue?vue&type=template&id=72b3c8c4"
import script from "./TodosStaleAssemblies.vue?vue&type=script&lang=js"
export * from "./TodosStaleAssemblies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports